import * as React from 'react';

import { ActionButtons } from '../../components/Header/parts/ActionButtons';
import { NewReviewButtonContainer } from '../NewReviewButton';
import { ActionButtonContainer } from '../ActionButton';

export const ActionButtonsContainer: React.FC = () => {
  return (
    <ActionButtons
      selections={<ActionButtonContainer />}
      newReview={<NewReviewButtonContainer size="XS" fill="fill_secondary" />}
    />
  );
};
